import { getSession } from 'next-auth/react';

export const clientSignOut = async () => {
  const session = await getSession();
  // Call the API route to revoke tokens on the server
  const access_token = session?.user?.access_token;
  const refresh_token = session?.user?.refresh_token;
  await fetch('/api/auth/signout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ access_token, refresh_token }),
  });
  let okta_logout_url;
  if (session?.okta_logout_url) {
    okta_logout_url = session.okta_logout_url;
  }
  if (okta_logout_url) {
    window.location.href = okta_logout_url;
  } else {
    window.location.href = '/auth/login';
  }
};
